import { useField } from 'formik';
import { type FC, type FocusEvent } from 'react';

import { DateField } from '../../InputFields';

interface FormikDateFieldProps {
  name: string;
  label: string;
  minDate?: Date;
  maxDate?: Date;
}

export const FormikDateField: FC<FormikDateFieldProps> = ({ name, label, minDate, maxDate }) => {
  const [field, meta, helpers] = useField(name);

  const handleBlur = (event: FocusEvent<HTMLInputElement>) => {
    if (event.target.name === name || event.target.id === name) {
      helpers.setTouched(true);
    }
  };

  return (
    <DateField
      id={name}
      name={name}
      value={field.value as Date}
      onChange={(value: Date | null) => {
        helpers.setValue(value);
      }}
      onBlur={handleBlur}
      label={label}
      {...(meta.touched && { helperText: meta.error })}
      {...(maxDate && { maxDate })}
      {...(minDate && { minDate })}
    />
  );
};
